module.exports = __webpack_public_path__ + "gt.svg?a89a8c63658733b54a8f347d557e9442";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/gt.svg
// module id = 1266
// module chunks = 27